import {
  Box, Skeleton, Button, List, ListItem, useTheme,
} from '@mui/material';

interface WalletListInfoCardSkeletonProps {
  numberOfItems?: number;
}

export function WalletListInfoCardSkeleton({ numberOfItems = 3 }: WalletListInfoCardSkeletonProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        padding: theme.spacing(3.125),
        width: '100%',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        borderRadius: theme.spacing(1.5),
        border: `1px solid ${theme.palette.grey[200]}`,
      }}
    >
      <Skeleton animation="wave" height={24} width="70%" />
      <List sx={{ width: '100%' }}>
        {Array.from({ length: numberOfItems }).map((_, index) => (
          <ListItem
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingLeft: 0,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(2),
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                  gap: theme.spacing(2),
                  width: '100%',
                }}
              >
                <Skeleton variant="circular" width={theme.spacing(5)} height={theme.spacing(5)} />
                <Skeleton animation="wave" height={24} width="60%" />
              </Box>
              <Skeleton animation="wave" height={16} width="10%"/>
            </Box>
          </ListItem>
        ))}
      </List>
      <Button
        fullWidth
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: theme.spacing(1),
        }}
      >
        <Skeleton animation="wave" height={24} width="50%" />
      </Button>
    </Box>
  );
}
